/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TrackingMelcoModelsCustomWarning,
    TrackingMelcoModelsCustomWarningFromJSON,
    TrackingMelcoModelsCustomWarningFromJSONTyped,
    TrackingMelcoModelsCustomWarningToJSON,
    TrackingMelcoModelsLogListItem,
    TrackingMelcoModelsLogListItemFromJSON,
    TrackingMelcoModelsLogListItemFromJSONTyped,
    TrackingMelcoModelsLogListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface TrackingMelcoModelsGenericList1MelcoModelsLogListItem
 */
export interface TrackingMelcoModelsGenericList1MelcoModelsLogListItem {
    /**
     * 
     * @type {Array<TrackingMelcoModelsLogListItem>}
     * @memberof TrackingMelcoModelsGenericList1MelcoModelsLogListItem
     */
    list: Array<TrackingMelcoModelsLogListItem>;
    /**
     * 
     * @type {Array<TrackingMelcoModelsCustomWarning>}
     * @memberof TrackingMelcoModelsGenericList1MelcoModelsLogListItem
     */
    warning_list?: Array<TrackingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof TrackingMelcoModelsGenericList1MelcoModelsLogListItem
     */
    total: number;
}

export function TrackingMelcoModelsGenericList1MelcoModelsLogListItemFromJSON(json: any): TrackingMelcoModelsGenericList1MelcoModelsLogListItem {
    return TrackingMelcoModelsGenericList1MelcoModelsLogListItemFromJSONTyped(json, false);
}

export function TrackingMelcoModelsGenericList1MelcoModelsLogListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingMelcoModelsGenericList1MelcoModelsLogListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(TrackingMelcoModelsLogListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(TrackingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function TrackingMelcoModelsGenericList1MelcoModelsLogListItemToJSON(value?: TrackingMelcoModelsGenericList1MelcoModelsLogListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(TrackingMelcoModelsLogListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(TrackingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


